/* eslint-disable */
import { StyleSheet, Dimensions } from 'react-native'
import { ApplicationStyles, Metrics, Fonts } from '../../Themes/'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: {
    flex: 1,
    paddingTop: 10,
    paddingBottom: 0,

    backgroundColor: Fonts.style.color.white
  },
  staticInfor : {
    marginLeft: 10,marginRight: 10
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  
  },
  buttonText: {
    fontFamily: Fonts.style.font.regular,
    color: '#FFFFFF'
  },
  buttonDisabledText: {
    fontFamily: Fonts.style.font.regular,
    color: '#AAAAAA'
  },
  buttonRight: {
    marginLeft: 42
  },
  button: {
    minWidth: '40%',
    width: 150, // web
    height: 30,
    borderRadius: 5
  },
  inputView: {
    flexDirection: 'row', justifyContent: 'space-between', marginTop: 10,
     marginLeft: 10,marginRight: 10
  },
  postLinkView: {
    flexDirection: 'row', justifyContent: 'space-between',
     marginLeft: 10,marginRight: 10, marginTop: 10
  },
  header: {
    marginBottom: 5
  },

  avatarContainerRow: {
    flexDirection: 'row',
    marginRight: 10
  },

  avatarSpacer: {
    height: 90
  },

  disableText: {
    color: Fonts.style.color.disable
  },

  avatarContainer: {
    height: 100,
    width: 100,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  textDescriptionContainer: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: 10,
    borderRadius: 5
  },
  textDescription: {
    fontSize: 16
  },
  avatarBorder: {
    paddingTop: 2,
    paddingLeft: 2,
    height: 80,
    width: 80,
  },
  avatar: {
    height: 80,
    width: 80,
    borderRadius: 40,
    borderColor: Fonts.style.color.baseRed,
    borderWidth: 2
  },
  profileText: {
    alignSelf: 'center', marginTop: 10, marginBottom: 20,
    fontFamily: Fonts.style.font.regular
  },
  statisticInfoContainer: {
    flexDirection: 'row',

  },
  statisticItem: {
    flex: 1,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF'
  },
  grayText: {
    color: '#d5d5d5'
  },
  plusIcon: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    backgroundColor: '#d5d5d5',
    height: 25,
    width: 25,
    justifyContent: 'center',
    alignItems: 'center'
  },
  textInputLink: {
    height: 35,
    borderColor: '#d5d5d5',
    borderRadius: 5,
    borderWidth: 1,
    flex: 1
  },
  tconContainer: {

    height: 30,
    width: 30,

    justifyContent: 'center',
    alignItems: 'center'
  },
  tconBorder: {
    width: 30,
    height: 30
  }
})
